import { toggleFullscreen } from '../../helpers';
import { LicenseType } from '../../enums';
import { LaunchData } from '../../models';
import { IntegrationBase } from './base';

export class FuturePlayIntegration extends IntegrationBase {

  public handleGameLoaded(launchData: LaunchData | null) {
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.game-load-complete' });
    if (launchData?.showPayTable) {
      this.rootStore.postMessageStore.sendOpenPayTable();
    }
    if (launchData?.licenseType === LicenseType.BrazilGLA) {
      this.rootStore.postMessageStore.sendIsBrazilGLA();
    }
    if (this.rootStore.sidebarMenuStore.showSidebar) {
      this.rootStore.sidebarMenuStore.sendSidebarPostMessage();
    }
  }

  public handleRoundStarted() {
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.game-animation-start' });
    this.rootStore.gameStore.setRoundInProgress(true);
  }

  public handleRoundFinished() {
    if (this.rootStore.jackpotStore.openJackpotSceneAfterRoundFinished) {
      this.rootStore.jackpotStore.showJackpotScene();
      this.rootStore.jackpotStore.setOpenJackpotSceneAfterRoundFinished(false)
    }
    if (this.rootStore.boostedJackpotStore.openBoostedJackpotAfterRoundFinished) {
      this.rootStore.boostedJackpotStore.showBoostedJackpotWheel();
      this.rootStore.boostedJackpotStore.setOpenBoostedJackpotAfterRoundFinished(false);
    }
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.game-animation-complete' });
    this.rootStore.gameStore.setRoundInProgress(false);
  }

  public exitGame(exitUrl = '') {
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.exit' });
    if (exitUrl) {
      window.location.href = exitUrl;
    } else {
      window.history.back();
    }
  }

  public handleToggleFullScreen() {
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.fullscreen' });
    toggleFullscreen();
  }

  public handleReload() {
    this.rootStore.postMessageStore.sendParentMessage({ type: 'agg.reload' });
    this.rootStore.gameStore.reloadGame();
  }

}
